module.exports = __webpack_public_path__ + "img/mainPage-icon2.780625f7.png";